import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getFileDetails } from '../../lib/helper'

export default class FileDetails extends Component {
  render() {
    const file = this.props.file
    const fileDetails = getFileDetails(file)
    const titles = Object.keys(fileDetails)
    const rows = titles.map(title => {
      return (
        <div className='attribute' key={title}>
          <span className='lbl'>{title}:</span>{' '}
          <span className='val'>{fileDetails[title]}</span>
        </div>
      )
    })

    return <div>{rows}</div>
  }
}

FileDetails.propTypes = {
  file: PropTypes.object
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/FileDetails.js
 **/